import React from "react";
import PropTypes from 'prop-types';
import { APIProvider } from '@vis.gl/react-google-maps';
import ClinicServices from './ClinicServices';

const apiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY ?? 'AIzaSyDKR2D-xrjNTAS-Ug5cL78tV5uwTkcIK0w';

ClinicFinder.propTypes = {
    config: PropTypes.object
};

export default function ClinicFinder({
    config
}) {
    return (
        <APIProvider apiKey={apiKey}>

            <ClinicServices config={config} />

        </APIProvider>

    );
};